import { launchColors } from '../launchTheme';
import { ProductFieldDef, ProductSection, ProductStatus } from '../types';

export const STATUS_OPTIONS: Array<{ value: Exclude<ProductStatus, ''>; label: string }> = [
  { value: 'coming', label: 'Kommande' },
  { value: 'active', label: 'Aktiv' },
  { value: 'order', label: 'Beställningsvara' },
  { value: 'outgoing', label: 'Utgående' },
  { value: 'discontinued', label: 'Utgått' },
];

export const statusLabel = (status: ProductStatus): string => STATUS_OPTIONS.find((option) => option.value === status)?.label || 'Ingen status';

export const statusStyle = (status: ProductStatus) => {
  if (status === 'active') return { fg: launchColors.mossDark, bg: launchColors.mossLight };
  if (status === 'coming') return { fg: launchColors.navy, bg: launchColors.softNavy };
  if (status === 'order') return { fg: launchColors.petrolDark, bg: launchColors.petrolLight };
  if (status === 'outgoing') return { fg: launchColors.warningText, bg: launchColors.warningBg };
  if (status === 'discontinued') return { fg: launchColors.textSecondary, bg: launchColors.neutralBg };
  return { fg: launchColors.textSecondary, bg: launchColors.card };
};

export const SECTION_LABELS: Record<ProductSection, string> = {
  names: 'Namn och texter',
  ean: 'EAN och förpackning',
  price: 'Pris och hållbarhet',
  systems: 'Namn i andra system',
  carton: 'Kartong och kommentar',
};

export const SECTION_ORDER: ProductSection[] = ['names', 'ean', 'price', 'systems', 'carton'];

export const QUICK_FILTERS: Array<{ value: string; label: string }> = [
  { value: 'missing', label: 'Saknar uppgifter' },
  { value: 'new', label: 'Kommande' },
  { value: 'ready', label: 'Klar för Dabas' },
  { value: 'warnings', label: 'Varningar' },
  { value: 'discontinued', label: 'Utgått' },
];

export const DABAS_ORDER = ['dabasName', 'category', 'eanConsumer', 'marketingText', 'searchWords'];

export function shownValue(field: ProductFieldDef, value: string): string {
  return field.kind === 'number' ? value.replace('.', ',') : value;
}

export function storedValue(field: ProductFieldDef, value: string): string {
  return field.kind === 'number' && /^-?\d+,\d+$/.test(value.trim()) ? value.trim().replace(',', '.') : value;
}

export function eanChecksumOk(value: string): boolean {
  if (!/^\d{8}$|^\d{12,14}$/.test(value)) return false;
  const digits = value.split('').map(Number);
  const check = digits.pop() as number;
  const sum = digits.reverse().reduce((total, digit, index) => total + digit * (index % 2 === 0 ? 3 : 1), 0);
  return (10 - (sum % 10)) % 10 === check;
}

export function personName(id: string, names: Record<string, string>): string {
  if (!id) return '';
  if (id === 'import') return 'Import';
  return names[id] || (/^[a-f0-9]{24}$/i.test(id) ? 'Okänd person' : id);
}

export function dateTimeText(value: string): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString('sv-SE', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export const productCommandId = () => `pi-${Date.now().toString(36)}-${Math.random().toString(16).slice(2, 8)}`;
